import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { reduxForm, Field, formValueSelector } from 'redux-form'
import labelAndInput from '../common/form/labelAndInput'
import RadioSimNao from '../common/form/radioSimNao'

import { init } from './usuarioAction'

class UsuarioForm extends Component {



    render() {
        const { handleSubmit, readOnly } = this.props

        return (
            <form role='form' onSubmit={handleSubmit}>

                <div className="box-body">

                    {/*<Field name='Campo de Pesquisa' component={InputPesquisa}
                        label='Campo de Pesquisa'
                        cols='12 4'
                        placeholder='Informe a pesquisa'
                        readOnly={readOnly}
        valueDesc='' />*/}

                    <Field name='id' component={labelAndInput}
                        label='Id'
                        cols='12 2'
                        placeholder='Id'
                        readOnly={true} />

                    <Field name='nome' component={labelAndInput}
                        label='Nome'
                        cols='12 5'
                        placeholder='Informe o nome'
                        readOnly={readOnly} />

                    <Field name='email' component={labelAndInput}
                        type='email'
                        label='E-mail'
                        cols='12 5'
                        placeholder='Informe o e-mail'
                        readOnly={readOnly} />

                    <Field name='senha' component={labelAndInput}
                        type='password' cols='12 3'
                        label='Senha' placeholder='Informe a senha'
                        readOnly={readOnly} />

                    <Field name='unidade' component={labelAndInput}
                        type='text' cols='12 3'
                        label='Unidades' placeholder='Informe separadas por virgula'
                        readOnly={readOnly} />

                    <Field name='ativo' component={RadioSimNao}
                        cols='12 3'
                        label='Status'
                        valueSim={true}
                        valueNao={false}
                        descSim={'Ativo'}
                        descNao={'Inativo'}
                        readOnly={readOnly} />

                    <Field name='adm' component={RadioSimNao}
                        cols='12 3'
                        label='Adm'
                        valueSim={true}
                        valueNao={false}
                        descSim={'Sim'}
                        descNao={'Não'}
                        readOnly={readOnly} />


                </div>
                <div className="boxfooter">
                    <button type='submit'
                        className={`btn btn-${this.props.submitClass}`}>
                        <i className={`fa fa-${this.props.iconSubmit}`}></i>
                        <span className='space-icon'>{this.props.submitLabel}</span>
                    </button>
                    <button type='button' className="btn btn-default"
                        onClick={this.props.init} ><i className="fa fa-ban"></i><span className='space-icon'>Cancelar</span></button>
                </div>
            </form>
        )
    }
}

UsuarioForm = reduxForm({ form: 'usuarioForm', destroyOnUnmount: false })(UsuarioForm)
const selector = formValueSelector('usuarioForm')
const mapStateToProps = state => ({

})
const mapDispatchToProps = dispatch => bindActionCreators({ init }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(UsuarioForm)



// WEBPACK FOOTER //
// ./src/usuario/usuarioForm.jsx